import React, { useMemo } from 'react';
import { View, Text, StyleSheet, useWindowDimensions } from 'react-native';
import KpiModuleCard from '../charts/KpiModuleCard';
import TrendKpiCard from '../charts/TrendKpiCard';
import MiniBarChart from '../charts/MiniBarChart';
import { calcToolboxFrequency, calcToolboxByPeriod, calcTrainingManHours } from '../kpiService';

interface Props {
  training:        any[];
  selectedPackage: string[] | null;
  config?:         any;
}

export default function WorkforceModule({ training, selectedPackage, config }: Props) {
  const { width } = useWindowDimensions();
  const isNarrow = width < 480;
  const toolbox     = useMemo(() => calcToolboxFrequency(training), [training]);
  const toolboxBars = useMemo(() => calcToolboxByPeriod(training), [training]);
  const manHours    = useMemo(() => calcTrainingManHours(training), [training]);

  const training_       = Array.isArray(training) ? training : [];
  const totalSessions   = training_.length;
  const totalAttendees  = training_.reduce((s: number, i: any) => s + (parseFloat(i.NoOfAttendees) || 0), 0);

  return (
    <KpiModuleCard title="Health, Safety & Workforce KPIs" accentColor="#00695C">
      <View style={styles.row}>

        {/* Training Summary */}
        <TrendKpiCard
          label="Training Sessions"
          value={totalSessions}
          unit="sessions"
          accent="#00695C"
          subtitle={`${totalAttendees.toLocaleString()} total attendees`}
        >
          {toolboxBars.length > 0 && (
            <MiniBarChart data={toolboxBars} barColor="#00695C" height={55} />
          )}
        </TrendKpiCard>

        {/* Man-Hours */}
        <TrendKpiCard
          label="Training Man-Hours"
          value={manHours.totalManHours.toLocaleString()}
          unit="man-hrs"
          accent="#00838F"
          subtitle={`avg ${totalSessions > 0 ? Math.round((manHours.totalManHours / totalSessions) * 10) / 10 : 0} hrs/session`}
        >
          {manHours.byPeriod.length > 0 && (
            <MiniBarChart data={manHours.byPeriod} barColor="#00838F" height={55} />
          )}
        </TrendKpiCard>

        {/* Toolbox Talks */}
        <TrendKpiCard
          label="Toolbox Talk Frequency"
          value={toolbox.sessions}
          unit="sessions"
          accent="#1565C0"
          subtitle={`${toolbox.attendees.toLocaleString()} total attendees`}
        />

      </View>
    </KpiModuleCard>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 10,
  },
});
